import React from 'react';

import { WHITE, PRIMARY_BLUE } from '@wetransfer/transfer/constant/colors';

const Video = () => (
  <svg viewBox="0 0 70 45" className="icon__advert-video">
    <g fill="none" fillRule="evenodd">
      <rect fill={PRIMARY_BLUE} width="70" height="45" rx="5" />
      <path
        d="M28 15.243c0-1.105.77-1.56 1.728-1.01l12.98 7.452c.953.548.956 1.434 0 1.984l-12.98 7.45c-.954.548-1.728.094-1.728-1.01V15.243z"
        fill={WHITE}
      />
    </g>
  </svg>
);

export default Video;
